import { render, staticRenderFns } from "./clientProfileManageCategory.vue?vue&type=template&id=41627454&scoped=true"
import script from "./clientProfileManageCategory.vue?vue&type=script&lang=js"
export * from "./clientProfileManageCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41627454",
  null
  
)

export default component.exports